import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { name: "b2b_contact_form" };
const _hoisted_2 = { class: "col-12 p-0 pb-3" };
const _hoisted_3 = { class: "col-12 p-0 pb-3" };
const _hoisted_4 = { class: "col-12 p-0 pb-3" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "text-left font8-responsive mb-3" }, [
    /*#__PURE__*/ _createTextVNode(" Hier finden Sie unsere "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/datenschutz",
        target: "_blank",
        title: "Datenschutzbestimmungen",
        class: "link-in-text"
    }, " Datenschutzerklärung ")
], -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "font7-responsive mb-4" }, "*Pflichtfeld", -1);
import { ref } from 'vue';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import { emailRequiredRule, firstNameRule } from '@/helpers/ValidationRules';
import axios from 'axios';
import eventBus from '@/services/EventBus';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContactForm',
    props: {
        formType: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const name = ref('');
        const email = ref('');
        const phone = ref('');
        const sendB2BContactMail = () => {
            axios
                .post('/b2b-contact', {
                name: name.value,
                email: email.value,
                phoneNumber: phone.value,
                type: props.formType,
            })
                .then(() => {
                // Function for Popup button:
                const reload = () => {
                    window.location.reload();
                };
                // Popup:
                eventBus.emit('openInfoPopup', {
                    icon: 'success',
                    headline: 'Nachricht versendet',
                    message: 'Vielen Dank für Ihre Anfrage.',
                    buttonConfirmText: 'Schließen',
                    buttonConfirmFunction: reload,
                    persistent: true,
                });
            })
                .catch((error) => {
                let serverResponseErrors = '';
                Object.values(error.response.data.errors).forEach((e) => {
                    serverResponseErrors += e;
                    serverResponseErrors += '<br />';
                });
                eventBus.emit('openInfoPopup', {
                    icon: 'error',
                    headline: 'Da ging was schief',
                    message: serverResponseErrors,
                });
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(BaseInput, {
                        name: "name",
                        modelValue: name.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                        id: "name",
                        placeholder: "Name*",
                        class: "showValidationErrorsCssOverride",
                        rules: _unref(firstNameRule)
                    }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(BaseEmailInput, {
                        name: "email",
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((email).value = $event)),
                        id: "email",
                        class: "showValidationErrorsCssOverride",
                        rules: _unref(emailRequiredRule)
                    }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(BaseInput, {
                        name: "phone",
                        modelValue: phone.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((phone).value = $event)),
                        id: "phone",
                        placeholder: "Telefonnummer (optional)"
                    }, null, 8, ["modelValue"])
                ]),
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("button", {
                    class: "buttonBase buttonGreen font6 w-sm-100 font6 mb-45",
                    type: "button",
                    id: "b2bSendContact",
                    onClick: _cache[3] || (_cache[3] = ($event) => (sendB2BContactMail()))
                }, " Anfrage absenden ")
            ]));
        };
    }
});
